import React, { useEffect, useState } from 'react';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';

const Directeur = () => {
  const [directeurs, setDirecteurs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDirecteurs = async () => {
      try {
        const response = await axios.get('/directeurs');
        setDirecteurs(response.data);
      } catch (error) {
        toast.error(error.response.data.error);
      }
    };
    fetchDirecteurs();
  }, []);

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Liste des directeurs successifs </h1>
      <div className="row">
        <div className="col">
          <Link to="/creatDirecteur" className="btn btn-outline-warning mb-3">
            Nouveau Directeur
          </Link>
        </div>
      </div>
      <table className="table table-striped">
        <thead className="thead-dark">
          <tr>
            <th>#</th>
            <th>Observation</th>
            <th>Nom Prénom</th>
            <th>Du</th>
            <th>Au</th>
            <th>Personnel</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {directeurs.length > 0 ? (
            directeurs.map((directeur, index) => (
              <tr key={directeur.id}>
                <td>{index + 1}</td>
                <td>{directeur.personnel?.grade?.name}</td>
                <td>{directeur.personnel ? directeur.personnel.nomprenom : 'N/A'}</td>
                <td>{directeur.du}</td>
                <td>{directeur.au}</td>
                <td>{directeur.personnelId}</td>
                <td className="col-md-1">
                  <i style={{ cursor: 'pointer' }} className="fa fa-eye mr-2" onClick={() => navigate(`/personnel/${directeur.personnel.id}`)}></i>
                  <i style={{ cursor: 'pointer' }} className="fa fa-pencil p-2 mr-2" onClick={() => navigate(`/directeurs/edit/${directeur.id}`)}></i>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                Aucun directeur trouvé.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Directeur;
